import { IconName } from '../icons/types';
import countryData from './country-data';
import { ParsePhone } from './types';

export const parsePhone = (phone: string): ParsePhone => {
  const country = Object.keys(countryData).find((data) =>
    phone.startsWith(`+${countryData[data].code}`)
  );

  if (!country) {
    return { country: 'US', number: phone };
  }

  const countryCode = countryData[country].code;

  if (countryCode === 1) {
    return { country: 'US', number: trimPhone(phone, countryCode) };
  }

  if (countryCode === 7) {
    return { country: 'RU', number: trimPhone(phone, countryCode) };
  }

  return { country: country as IconName, number: trimPhone(phone, countryCode) };
};

const trimPhone = (phone: string, code: number) => {
  return phone.slice(phone.indexOf(code.toString()) + code.toString().length);
};
